import { isDefined as l } from "./types3.mjs";
import { EXTENSION_TO_MIME_TYPES_MAP as u, ONE_KBYTE as i } from "./constants26.mjs";
const D = (e, t) => t.find((r) => r.uid === e.uid), O = (e) => ({
  ...e,
  lastModified: e.lastModified,
  lastModifiedDate: e.lastModifiedDate,
  name: e.name,
  size: e.size,
  type: e.type,
  uid: e.uid,
  originFile: e,
  percent: 0
});
function h(e) {
  return l(e) ? `The file size should not exceed ${e} Mb` : "The file exceeds the allowed size";
}
function g(e) {
  return l(e) ? `The file size must not be less than ${e} Mb` : "The file is smaller than the allowed size";
}
function M(e) {
  return e ? `You can only upload a file type ${e}` : "Invalid file type";
}
function E() {
  return "An error occurred while uploading the file";
}
function F(e) {
  return `The maximum allowed number of files is ${e}`;
}
const j = (e, t = {}, r, c = {}) => {
  const {
    getMinSizeErrorText: a = g,
    getSizeErrorText: f = h,
    getFormatErrorText: d = M,
    getCustomErrorText: m = E,
    getMaxFilesCountErrorText: p = F
  } = c;
  if (r) {
    for (let n = 0; n < r.length; n++)
      if (r[n].errorType === e)
        return r[n].text;
  }
  if (e === "maxSize")
    return f(t.maxSize);
  if (e === "minSize")
    return a(t.minSize);
  if (e === "maxFilesCount")
    return p(t.maxFilesCount);
  if (e === "types") {
    const n = t.types, s = n ? Object.keys(u).filter(
      (o) => n.includes(o) || n.some(
        (T) => u[o].includes(T)
      )
    ) : [], x = s.length === (t.types || []).length && s.map((o) => o.toUpperCase()).join(", ");
    return d(x);
  }
  return m();
}, S = (e = {}) => (e.types || []).join(", "), _ = (e) => {
  const t = i, r = i * i;
  return typeof e > "u" ? "" : e < t ? e + "B" : e < r ? (e / t).toFixed(2) + "KB" : (e / r).toFixed(2) + "MB";
};
export {
  O as fileToObject,
  D as findFileInList,
  _ as formatFileSize,
  S as getAcceptFromValidation,
  j as getValidationErrors
};
//# sourceMappingURL=utils3.mjs.map
